import { useATSQuery } from '@viome/viome-base/src/api/Strapi/useStrapi';
import type {
  AtsMetaData,
  Section,
} from '@viome/viome-base/src/api/Strapi/StrapiTypes';

function findSection(sections: Section[], title: string): Section | undefined {
  return sections.find(
    (s) => s.title.toLowerCase() === title.toLowerCase(),
  );
}

export function getATSSections(data: AtsMetaData) {
  const { sections } = data;
  return {
    howToUse: findSection(sections, 'How to use it'),
    howItWorks: findSection(sections, 'How it works'),
    whatsInside: findSection(sections, "What's inside"),
    delivered: sections.find((s) => s.highlights?.length),
    supplement: sections.find((s) => s.ingredients?.length),
    faq: sections.find((s) => s.faqs?.length),
    disclaimer: sections.find((s) => s.text),
  };
}

export function useATSData() {
  const { data, isLoading, isError } = useATSQuery();

  return {
    data: data ?? null,
    isLoading,
    isError,
  };
}
